import { Component, Input, OnInit, OnDestroy, ElementRef, ViewChild, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-counter',
    templateUrl: './counter.component.html',
    styleUrls: ['./counter.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CounterComponent implements OnInit, OnDestroy, OnChanges {
  @Input() targetValue: number = 0;
  @Input() duration: number = 2000; // milliseconds
  @Input() label: string = '';
  @Input() icon: string = '';

  @ViewChild('counterElement', { static: true }) counterElement!: ElementRef;

  currentValue: number = 0;
  private animationId: any;
  private observer!: IntersectionObserver;
  private hasAnimated: boolean = false;

  ngOnInit() {
    this.setupIntersectionObserver();
  }
  ngOnChanges(changes: SimpleChanges) {
    // targetValue değiştiğinde animasyonu yeniden başlat
    if (changes['targetValue'] && !changes['targetValue'].firstChange) {
      this.hasAnimated = false;
      this.setupIntersectionObserver();
    }
  }

  ngOnDestroy() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private setupIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.startAnimation();
            this.hasAnimated = true;
          }
        });
      },
      { threshold: 0.5 }
    );

    this.observer.observe(this.counterElement.nativeElement);
  }

  private startAnimation() {
    const startTime = Date.now();
    const startValue = 0;
    const endValue = this.targetValue;

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / this.duration, 1);
      
      // Easing function (easeOutQuart)
      const easeProgress = 1 - Math.pow(1 - progress, 4);
      
      this.currentValue = Math.floor(startValue + (endValue - startValue) * easeProgress);

      if (progress < 1) {
        this.animationId = requestAnimationFrame(animate);
      } else {
        this.currentValue = endValue;
      }
    };

    animate();
  }
}
